import { formatArgForLog } from './logging';

/**
 * Casts a string as an enum, where appropriate
 */
export function enumFromStringValue<T>(
  enumObject: { [s: string]: T },
  value?: string
): T | undefined {
  if (!value) {
    return undefined;
  }
  return (Object.values(enumObject) as unknown as string[]).includes(value)
    ? (value as unknown as T)
    : undefined;
}

function listSupportedValues(supportedValues?: readonly unknown[]): string {
  if (!supportedValues) {
    return '';
  }
  return `\nSupported values: [${supportedValues.join(', ')}]`;
}
export class UnhandledValueError extends Error {
  constructor(value: unknown, supportedValues?: readonly unknown[]) {
    super(
      `Unsupported value: '${formatArgForLog(
        value as never
      )}'${listSupportedValues(supportedValues)}`
    );
  }
}

/**
 * Can be used to statically assert that a switch statement covers all
 * cases of an enum. Usage:
 *
 * default:
 *   return assertUnreachable(value);
 */
export const assertUnreachable = (
  x: never,
  supportedValues?: readonly unknown[]
): never => {
  throw new UnhandledValueError(x, supportedValues);
};
